module.exports = __webpack_public_path__ + "img/image16.f7fb29ef.jpg";